import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { type UseIdentityProps, useIdentity } from "./useIdentity";
import useReauthentication, {
	type UseAuthenticationProps,
} from "./useReauthentication";

export interface UseAuthorizationOrRedirectProps
	extends UseIdentityProps,
		UseAuthenticationProps {
	redirect: string;
}

export const useAuthorizationOrRedirect = ({
	token,
	redirect,
	setToken,
}: UseAuthorizationOrRedirectProps) => {
	const navigate = useNavigate();
	const location = useLocation();

	const identity = useIdentity({ token });

	const invalidToken = !identity.isLoading && !identity.isIdentified;

	useEffect(() => {
		if (invalidToken) {
			navigate(redirect, { state: { from: location }, replace: true });
			setToken(null);
		}
	}, [invalidToken, location, navigate, redirect, setToken]);

	useReauthentication({
		token: invalidToken ? null : token,
		setToken,
	});

	return identity;
};
